<template>
    <div class="alert">
        <div class="alert-icon" :class="styleClass">
            <font-awesome-icon v-if="type === 'primary' || type === 'info'" icon="info-circle"/>
            <font-awesome-icon v-if="type === 'warning' || type === 'danger'" icon="exclamation"/>
            <font-awesome-icon v-if="type === 'success'" icon="check"/>
        </div>
        {{text}}
    </div>
</template>
<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faInfoCircle, faExclamation, faCheck} from '@fortawesome/free-solid-svg-icons'

    library.add(faInfoCircle, faExclamation, faCheck);

    export default {
        props: {
            type: {
                type: String,
                default: 'primary',
            },
            text: {
                type: String,
                required: true,
            }
        },
        computed: {
            styleClass() {
                return 'bg-' + this.type;
            }
        }
    }
</script>
<style lang="scss">
    .alert {
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 4px;
        position: relative;
        padding-left: 62px;

        .alert-icon {
            position: absolute;
            top: -1px;
            left: -1px;
            bottom: -1px;
            width: 48px;
            line-height: 48px;
            text-align: center;
            color: #fff;
            border-radius: 4px 0 0 4px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/standard-alert.vue